// Industry complexity multipliers (affects dev time and maintenance)
export const INDUSTRIES = {
  saas: { name: 'SaaS / Technology', multiplier: 1.0, description: 'Product pages, integrations, documentation' },
  ecommerce: { name: 'E-commerce', multiplier: 1.4, description: 'Product catalogs, checkout, inventory' },
  fintech: { name: 'Financial Services', multiplier: 1.5, description: 'Compliance, security, regulations' },
  healthcare: { name: 'Healthcare', multiplier: 1.6, description: 'HIPAA compliance, patient portals' },
  media: { name: 'Media / Publishing', multiplier: 1.2, description: 'Content-heavy, high traffic' },
  professional: { name: 'Professional Services', multiplier: 0.9, description: 'Lead gen, case studies, team pages' },
  nonprofit: { name: 'Non-profit', multiplier: 0.85, description: 'Donations, events, campaigns' },
};
